export default __webpack_public_path__ + "static/media/stay-bright.441ca5f8.svg";